import { useMemo } from 'react';
import { activeSupplierStatusIds } from '@/configs/supplier-config';
import { useGetSuppliers } from '@/services/apis/queries/suppliers/use-get-suppliers';
import type { Option } from '@/types/data-table';
import { mapSuppliersToOptions } from './map-suppliers-to-options';

export function useSupplierOptions(): { supplierOptions: Option[] } {
  const { data: suppliers } = useGetSuppliers({
    statusIds: activeSupplierStatusIds,
  });
  const supplierOptions = useMemo<Option[]>(
    () => mapSuppliersToOptions(suppliers),
    [suppliers],
  );

  return {
    supplierOptions,
  };
}
